import React, { useState } from "react";

const API_BASE = "https://summerhousagentlive.onrender.com/api";

const ReviewForm = ({ propertyId, onNewReview }) => {
  const [reviewerName, setReviewerName] = useState("");
  const [rating, setRating] = useState(5);
  const [reviewText, setReviewText] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    // ส่ง null ถ้าไม่มี property
    formData.append("property_id", propertyId ?? "");
    formData.append("reviewer_name", reviewerName);
    formData.append("rating", rating);
    formData.append("review_text", reviewText);

    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }

    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}/reviews`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Error submitting review");

      // Reset form
      setReviewerName("");
      setRating(5);
      setReviewText("");
      setImages([]);
      onNewReview(); // refresh list
    } catch (err) {
      console.error(err);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    padding: "12px 15px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    outline: "none",
    fontSize: "1rem",
    width: "100%",
    boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
    transition: "border 0.3s, box-shadow 0.3s",
  };

  const inputFocusStyle = {
    borderColor: "#0a71e7",
    boxShadow: "0 4px 12px rgba(10,113,231,0.2)",
  };

  const buttonStyle = {
    padding: "12px 20px",
    borderRadius: "12px",
    border: "none",
    backgroundColor: "#0a71e7",
    color: "#fff",
    fontWeight: "600",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.2s",
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        marginBottom: "2rem",
        backgroundColor: "#fff",
        padding: "50px",
        borderRadius: "15px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      }}
    >
            <input
        type="text"
        placeholder="Your Name"
        value={reviewerName}
        onChange={(e) => setReviewerName(e.target.value)}
        required
        style={inputStyle}
        onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
        onBlur={(e) => Object.assign(e.target.style, inputStyle)}
        />

      <select
        value={rating}
        onChange={(e) => setRating(Number(e.target.value))}
        style={inputStyle}
        onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
        onBlur={(e) => Object.assign(e.target.style, inputStyle)}
      >
        {[1, 2, 3, 4, 5].map((n) => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>


        <textarea
        placeholder="Your Review"
        value={reviewText}
        onChange={(e) => setReviewText(e.target.value)}
        style={{ ...inputStyle, minHeight: "100px", resize: "vertical" }}
        onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
        onBlur={(e) => Object.assign(e.target.style, inputStyle)}
        />


      <input
        type="file"
        multiple
        accept="image/*"
        onChange={(e) => setImages([...e.target.files])}
        style={{ marginTop: "5px" }}
      />

      {images.length > 0 && (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          {images.map((img, idx) => (
            <img
              key={idx}
              src={URL.createObjectURL(img)}
              alt="preview"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "10px",
                border: "1px solid #eee",
              }}
            />
          ))}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        style={{
          ...buttonStyle,
          backgroundColor: loading ? "#6ea0f0" : "#0a71e7",
          transform: loading ? "scale(0.98)" : "scale(1)",
        }}
      >
        {loading ? "Submitting..." : "Submit Review"}
      </button>
    </form>
  );
};



export default ReviewForm;
